import Event from 'console/tabs/legacy/event';
import { rusTimeDateLikeAPlus } from 'utils';
import { EventDesc } from 'console/device/device-event';
import { useAppSelector } from 'shared/hooks/redux/hooks';
export function onNewEvent(event, device_name) {
    return new Event({
        ...event,
        details: `<div class='infobox-tooltip' >
                                <img src="${window.ZONT_URL.api_event_icon}?type=${event.icon}" alt="${event.title}"/>
                                <span>${event.title}</span></br>
                              </div>`,
        time: 0,
        title: rusTimeDateLikeAPlus(new Date(event.time * 1e3)),
        device_name,
    });
}
const excluded_event_kinds = ['connection', 'gps', 'gsm', 'staff'];
const technicalUserAlarms = [
    /WARNING! Internal RTC failed!/,
    /Встроенные часы неисправны!/,
    /Не удалось сохранить конфигурацию. Code/,
    /Не удалось сохранить конфигурацию. TMP_FILE_BUSY_ERROR/,
    /Количество ошибок памяти больше допустимого/,
    /Не удалось сохранить файл конфигурации/,
    /Внимание! Произошла ошибка выделения памяти/,
];
function isTechnicalEvent(title) {
    return technicalUserAlarms.some((re) => re.test(title));
}
export function isExcludedEventType(user_filters, show_network_events, event_type) {
    const filter = EventDesc[event_type];
    if (filter == null) {
        return false;
    }
    const { filter: kind } = filter;
    if (kind == 'unknown') {
        return !show_network_events;
    }
    if (user_filters && user_filters[kind] == false) {
        return true;
    }
    if (!show_network_events) {
        if (excluded_event_kinds.includes(kind)) {
            return true;
        }
    }
    return false;
}
export function eventsStateFiltered(user_filters, show_network_events, event) {
    const { type, title } = event;
    if (!show_network_events) {
        if (isTechnicalEvent(title)) {
            return false;
        }
    }
    const is_excluded = isExcludedEventType(user_filters, show_network_events, type);
    return !is_excluded;
}
export function useNetworkEvent() {
    const show_network_events = useAppSelector((state) => !!state.account.show_network_events);
    const is_staff = useAppSelector((state) => state.account.is_staff);
    return show_network_events || is_staff;
}
